import { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router';
import type { BookingDto } from '@bingo/shared';
import { api } from '../lib/api';
import { longDate } from '../lib/dates';
import { useT } from '../lib/i18n';
import { BookingPanel, mayLeaveBookingPanel } from '../components/BookingPanel';
import { BookingRow } from './Bookings';

export function MissingInfo() {
  const [bookings, setBookings] = useState<BookingDto[] | null>(null);
  const [open, setOpenRaw] = useState<BookingDto | null>(null);
  /** Opening another booking (or a new one) asks first when the panel holds unsaved changes. */
  const setOpen = (v: BookingDto | null) => { if (v !== open && mayLeaveBookingPanel()) setOpenRaw(v); };
  const t = useT();

  const load = useCallback(async () => {
    setBookings((await api<{ bookings: BookingDto[] }>('/api/bookings/missing')).bookings);
  }, []);
  useEffect(() => void load(), [load]);

  const byDate = useMemo(() => {
    const m = new Map<string, BookingDto[]>();
    for (const b of bookings ?? []) m.set(b.date, [...(m.get(b.date) ?? []), b]);
    return [...m.entries()];
  }, [bookings]);

  return (
    <div className="stack">
      <div className="page-head">
        <div>
          <h1>{t('Missing info')}</h1>
          <div className="muted" style={{ fontSize: 14 }}>{t('Bookings from today on with no pickup time, phone, hotel or tour. Nearest date first.')}</div>
        </div>
        <Link className="btn" to="/bookings">{t('Back to bookings')}</Link>
      </div>
      {!bookings ? <div className="muted">{t('Loading…')}</div> : bookings.length === 0 ? (
        <div className="card section">{t('Nothing missing. Well done.')}</div>
      ) : byDate.map(([date, list]) => (
        <div key={date} className="card blist">
          <div className="blist-head"><b>{longDate(date)}</b><span className="muted">{t('{n} to complete', { n: list.length })}</span></div>
          {list.map((b) => <BookingRow key={b.id} b={b} showTour onOpen={() => setOpen(b)} />)}
        </div>
      ))}
      {open && <BookingPanel key={open.id} booking={open} date={open.date} onClose={() => setOpenRaw(null)} onSaved={() => void load()} />}
    </div>
  );
}
